<app-card-widget title="Finances (old)" *ngIf="invoice$ | async">

  <form [formGroup]="form" id="invoice-financing-form" (ngSubmit)="save()" *ngIf="maps$ | async as maps" novalidate>

    <div class="card-section-container">
      <div class="card-section">

        <app-text label="Configuration" *ngIf="!edited">{{maps.configurations.get(invoice.invoiceConfigurationId)?.name}}</app-text>

        <mat-form-field *ngIf="edited">
          <mat-select placeholder="Configuration" formControlName="invoiceConfigurationId">
            <mat-option *ngFor="let option of maps.configurations.all()" [value]="option.invoiceConfigurationId">
              {{option.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <app-text label="Financing Method" *ngIf="!edited">{{maps.financingMethods.get(invoice.financingMethodId)?.name}}</app-text>

        <mat-form-field *ngIf="edited">
          <mat-select placeholder="Financing Method" formControlName="financingMethodId">
            <mat-option *ngFor="let option of maps.financingMethods.all()" [value]="option.financingMethodId">
              {{option.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <app-text label="Daily Interest (%)" *ngIf="!edited && invoice.financingMethodId === FinancingMethodId.DailyInterest">{{invoice.dailyInterest | number:'0.3-3'}}</app-text>

        <mat-form-field *ngIf="edited && form.value.financingMethodId === FinancingMethodId.DailyInterest">
          <input matInput placeholder="Daily Interest (%)" type="number" formControlName="dailyInterest" step="0.01" />
        </mat-form-field>

        <app-text label="Fixed Interest (%)" *ngIf="!edited && invoice.financingMethodId === FinancingMethodId.FixedInterest">{{invoice.fixedInterest | number:'0.3-3'}}</app-text>

        <mat-form-field *ngIf="edited && form.value.financingMethodId === FinancingMethodId.FixedInterest">
          <input matInput placeholder="Fixed Interest (%)" type="number" formControlName="fixedInterest" step="0.01" />
        </mat-form-field>

        <app-text label="Penalty Interest Method" *ngIf="!edited">{{maps.penaltyInterestMethods.get(invoice.penaltyInterestMethodId)?.name}}</app-text>

        <mat-form-field *ngIf="edited">
          <mat-select placeholder="Penalty Interest Method" formControlName="penaltyInterestMethodId">
            <mat-option [value]="null"></mat-option>
            <mat-option *ngFor="let option of maps.penaltyInterestMethods.all()" [value]="option.penaltyInterestMethodId">
              {{option.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <app-text label="Guarantee (%)" *ngIf="!edited">{{invoice.guarantee | number:'0.2-2'}}</app-text>

        <mat-form-field *ngIf="edited">
          <input matInput placeholder="Guarantee (%)" type="number" formControlName="guarantee" />
        </mat-form-field>

      </div>
      <div class="card-section">

        <app-text label="Financed Days">{{invoice.financedDays}}</app-text>
        <app-text label="Express Payment Fee">{{invoice.expressPaymentFee | currency:'EUR'}}</app-text>

      </div>
      <div class="card-section">

        <mat-form-field *ngIf="edited">
          <input matInput placeholder="Service Fee (%)" type="number" formControlName="serviceFee" />
          <span matSuffix>(incl. {{invoice.serviceFeeVat}}% VAT)</span>
        </mat-form-field>
        <app-text label="Service Fee" *ngIf="!edited">{{invoice.serviceFee | currency:'EUR'}} (incl. {{invoice.serviceFeeVat}}% VAT)</app-text>
        <app-text label="Financing Fee">{{invoice.financingFee | currency:'EUR'}}</app-text>
        <app-text label="Penalty Interest Fee">{{invoice.penaltyInterestFee | currency:'EUR'}}</app-text>

        <mat-form-field *ngIf="edited">
          <input matInput placeholder="Subfinancing Cost (€)" type="number" formControlName="subfinancingCost" />
        </mat-form-field>
        <app-text label="Subfinancing Cost" *ngIf="!edited">{{invoice.subfinancingCost | currency:'EUR'}}</app-text>

        <app-text label="Total Profit">{{invoice.totalProfit | currency:'EUR'}}</app-text>

      </div>
    </div>

    <div style="height: 32px"></div>

    <div class="card-section-container">
      <div class="card-section">
        <app-text label="Due Date">{{invoice.dueDate | date:'shortDate'}}</app-text>
      </div>
      <div class="card-section">
        <ng-container *ngIf="modernInvoice$ | async as modern">
          <app-text label="Interest End Date" *ngIf="!edited">
            <ng-container *ngIf="modern.effective_interest_end_date; else missingInterestEndDate">{{modern.effective_interest_end_date | date:'shortDate'}}</ng-container>
            <ng-template #missingInterestEndDate><span class="missing-interest-end-date" title="No due date, last payment date or override">—</span></ng-template>
            <span *ngIf="modern.interest_end_date_override"> (override)</span>
          </app-text>

          <mat-form-field *ngIf="edited">
            <input matInput [matDatepicker]="interestEndDateOverridePicker" placeholder="Interest End Date Override" formControlName="interestEndDateOverride" />
            <mat-datepicker-toggle matSuffix [for]="interestEndDateOverridePicker"></mat-datepicker-toggle>
            <mat-datepicker #interestEndDateOverridePicker></mat-datepicker>
            <button type="button" mat-icon-button matSuffix *ngIf="form.get('interestEndDateOverride').value" (click)="clearInterestEndDateOverride()" aria-label="Clear override">
              <mat-icon>clear</mat-icon>
            </button>
            <mat-hint>Leave empty to use due date / actual payment date.</mat-hint>
          </mat-form-field>
        </ng-container>
      </div>
      <div class="card-section"></div>
    </div>

    <div style="height: 32px"></div>

    <div class="card-section-container">
      <div class="card-section">

        <app-text label="Financed Date" *ngIf="!edited">{{invoice.dateFinanced | date:'shortDate'}}</app-text>

        <mat-form-field *ngIf="edited">
          <input matInput [matDatepicker]="dateFinancedPicker" placeholder="Financed Date" formControlName="dateFinanced" />
          <mat-datepicker-toggle matSuffix [for]="dateFinancedPicker"></mat-datepicker-toggle>
          <mat-datepicker #dateFinancedPicker></mat-datepicker>
        </mat-form-field>

        <app-text *ngIf="!edited" label="Financed Amount">{{invoice.amountFinanced | currency:'EUR'}}</app-text>

        <mat-form-field *ngIf="edited">
          <input matInput placeholder="Financed Amount" type="number" formControlName="amountFinanced" />
        </mat-form-field>

      </div>
      <div class="card-section">
        <app-text label="Final Payment Date" *ngIf="!edited">{{invoice.finalPaymentDate| date:'shortDate'}}</app-text>

        <mat-form-field *ngIf="edited">
          <input matInput [matDatepicker]="finalPaymentDatePicker" placeholder="Final Payment Date" formControlName="finalPaymentDate" />
          <mat-datepicker-toggle matSuffix [for]="finalPaymentDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #finalPaymentDatePicker></mat-datepicker>
        </mat-form-field>

        <app-text *ngIf="!edited" label="Final Payment Amount">{{invoice.finalPaymentAmount | currency:'EUR'}}</app-text>

        <mat-form-field *ngIf="edited">
          <input matInput placeholder="Final Payment Amount" type="number" formControlName="finalPaymentAmount" />
        </mat-form-field>

      </div>
      <div class="card-section">
        <app-text label="Last Payment Date" *ngIf="!edited">{{invoice.lastPaymentDate | date:'shortDate'}}</app-text>

        <mat-form-field *ngIf="edited">
          <input matInput [matDatepicker]="lastPaymentDatePicker" placeholder="Last Payment Date" formControlName="lastPaymentDate" />
          <mat-datepicker-toggle matSuffix [for]="lastPaymentDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #lastPaymentDatePicker></mat-datepicker>
        </mat-form-field>

        <app-text label="Total Paid Amount">{{invoice.totalPaidAmount | currency:'EUR'}}</app-text>
      </div>
    </div>

  </form>

  <mat-menu #action="matMenu">
    <button mat-menu-item (click)="calculateInterests()">Calculate Interests</button>
    <button mat-menu-item (click)="calculateInterestsLegacy()">Calculate Interests (old)</button>
    <button mat-menu-item (click)="updateLastPaymentDateFromArex()">Update Last Payment Date from Arex</button>
  </mat-menu>

  <mat-card-actions align="end">
    <button type="button" mat-button *ngIf="!edited" [disabled]="locked" [matMenuTriggerFor]="action">Action</button>
    <button type="button" mat-button *ngIf="!edited" [disabled]="locked" (click)="edit()">Edit</button>
    <button type="submit" mat-button *ngIf="edited" [disabled]="!form.valid" form="invoice-financing-form">Save</button>
    <button type="reset" mat-button *ngIf="edited" (click)="revert()">Cancel</button>
  </mat-card-actions>

</app-card-widget>


